import { fade } from "@material-ui/core/styles/colorManipulator";

const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles(({ palette: { custom, primary } }) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  root_head: {
    fontWeight: 600,
    "&$root_card": {
      boxSizing: "border-box",
      padding: "0 4px",
    },
  },
  root_body: {
    "&$root_default": {
      minHeight: 48,
      borderTop: `1px solid ${custom.border[200]}`,
      "&$root_hoverable:hover": {
        background: fade(custom.low, 0.05),
      },
      "&$root_selected": {
        background: fade(primary.main, 0.1),
        "&$root_hoverable:hover": {
          background: fade(primary.main, 0.15),
        },
      },
    },
    "&$root_card": {
      boxSizing: "border-box",
      marginTop: 8,
      minHeight: 48,
      padding: "0 4px",
      background: custom.high,
      borderRadius: 4,
      border: `1px solid ${custom.border[100]}`,
      "&:first-child": {
        marginTop: 0,
      },
      "&$root_hoverable:hover": {
        background: fade(custom.low, 0.05),
      },
      "&$root_expanded": {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      "&$root_selected": {
        background: fade(primary.main, 0.1),
        "&$root_hoverable:hover": {
          background: fade(primary.main, 0.15),
        },
      },
    },
    "&$root_striped": {
      minHeight: 48,
      borderTop: `1px solid ${custom.border[200]}`,
      "&$root_even": {
        background: custom.high,
        "&$root_hoverable:hover": {
          background: fade(custom.low, 0.05),
        },
        "&$root_selected": {
          background: fade(primary.main, 0.1),
          "&$root_hoverable:hover": {
            background: fade(primary.main, 0.15),
          },
        },
      },
      "&$root_odd": {
        background: custom.bg[100],
        "&$root_hoverable:hover": {
          background: fade(custom.low, 0.1),
        },
        "&$root_selected": {
          background: fade(primary.main, 0.2),
          "&$root_hoverable:hover": {
            background: fade(primary.main, 0.25),
          },
        },
      },
    },
  },
  root_default: {},
  root_card: {},
  root_striped: {},
  root_even: {},
  root_odd: {},
  root_expanded: {},
  root_selected: {},
  root_hoverable: {},
  selectCell: {
    flex: "0 40px",
    textAlign: "center",
  },
  expandCell: {
    flex: "0 40px",
    textAlign: "center",
  },
  expand: {
    "&$expand_card": {
      boxSizing: "border-box",
      marginBottom: 8,
      background: custom.high,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      border: `1px solid ${custom.border[100]}`,
      borderTop: 0,
    },
    "&$expand_striped": {
      "&$expand_even": {
        background: custom.high,
      },
      "&$expand_odd": {
        background: custom.bg[100],
      },
    },
  },
  expand_default: {},
  expand_card: {},
  expand_striped: {},
  expand_even: {},
  expand_odd: {},
  expandIcon: {
    position: "relative",
    transition: "transform 200ms",
    "&::before": {
      content: "''",
      position: "absolute",
      width: 48,
      height: 48,
    },
  },
  expandIcon_expanded: {
    transform: "rotateZ(180deg)",
  },
}));

export default useStyles;
